module.exports = __webpack_public_path__ + "5ed3c89858cd71485e8849796b6b4095.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/picture/Yaletown.jpg
// module id = 552
// module chunks = 0